import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { NgxExtendedPdfViewerModule } from 'ngx-extended-pdf-viewer';
import { PdfPreviewComponent } from '@core/components/pdf-preview/pdf-preview.component';
import { PdfPreviewRoutingModule } from '@core/components/pdf-preview/pdf-preview-routing.module';

@NgModule({
  imports: [
    CommonModule,
    PdfPreviewRoutingModule,
    NgxExtendedPdfViewerModule,
  ],
  declarations: [PdfPreviewComponent],
  providers: []
})
export class PdfPreviewModule {}
